import { memo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { FullPageAppTemplate } from 'modules/app-registry/templates'
import { useNavigate } from 'react-router-dom'
import { useHistory } from 'shared/hooks/useHistory'
import { useUserContext } from 'shared/hooks/useUserContext'

import styles from './CoursesApp.module.scss'

const CoursesApp = memo(
  () => {
    const navigate = useNavigate()
    const { location } = window
    const history = useHistory()
    const { user } = useUserContext()
    const { apps } = useAvailableApps()

    return (
      <FullPageAppTemplate
        appId={AppId.COURSES}
        scope='courses'
        envKey={apps[AppId.COURSES].runtimeEnvKey}
        entryPath='./CoursesApp'
        url={process.env.REACT_APP_COURSES_APP_DEV_PATH}
        appName={apps[AppId.COURSES].name}
        className={styles.coursesAppWrapper}
        appProps={{
          user,
          history,
          appPath: apps[AppId.COURSES].path,
          initialPath: location.pathname,
          onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
            const { pathname } = location

            if (pathname !== nextPathname) {
              navigate(nextPathname)
            }
          }
        }}
      />
    )
  },
  // when there are no props, this is OK to use. without this comparison function, we will have higher memory usage
  () => true
)

export { CoursesApp }
